import { Injectable } from '@angular/core';

import { MarketGroupingConfig } from '@frontend/sports/common/client-config-data-access';
import { MediaQueryService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class SheetViewService {
    private readonly _isEnabled: boolean;

    constructor(
        private mediaObserver: MediaQueryService,
        private marketGroupingConfig: MarketGroupingConfig,
    ) {
        this._isEnabled = this.marketGroupingConfig.shouldShowSheetViewForAllMarkets && this.mediaObserver.isActive('xs');
    }

    get isEnabled(): boolean {
        return this._isEnabled;
    }
}
